import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=a7d0686a&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=a7d0686a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d0686a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7d0686a')) {
      api.createRecord('a7d0686a', component.options)
    } else {
      api.reload('a7d0686a', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=a7d0686a&scoped=true&", function () {
      api.rerender('a7d0686a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/album_detail/attribute.vue"
export default component.exports